/**
 * Rotulo exibido para uma opcao do filtro de Categoria de material.
 *
 * A categoria canonica cai no NCM quando o ERP nao mandou categoria, e ha tenant onde ISSO E A
 * REGRA: numa base real, um tenant tinha 100% dos produtos so com NCM — o filtro abriria com dezenas
 * de numeros de 8 digitos e nenhuma pista do que sao. O prefixo resolve a leitura sem mexer no valor
 * enviado a API, que continua sendo o codigo puro.
 */
export const rotuloCategoria = (valor: string): string =>
  /^\d+$/.test(valor) ? `NCM ${valor}` : valor
